export const getBordeauxData = () => ({
  name: "Bordeaux",
  country: "France",
  description: "Bordeaux est la plus grande région viticole de France, célèbre pour ses vins rouges prestigieux et ses grands châteaux.",
  type: "region",
  subregions: {
    medoc: {
      name: "Médoc",
      description: "Le Médoc est la région des grands crus classés, produisant des vins rouges élégants et structurés.",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols de graves et argiles",
        viticulture: "Rendements limités, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Merlot", "Cabernet Franc", "Petit Verdot"],
        white: ["Sauvignon Blanc", "Sémillon", "Muscadelle"]
      },
      wineStyles: {
        red: "Vins rouges structurés avec des tannins fermes et un excellent potentiel de vieillissement",
        white: "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, chocolat noir"
    },
    saint_emilion: {
      name: "Saint-Émilion",
      description: "Saint-Émilion produit des vins rouges élégants et accessibles, dominés par le Merlot.",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Argiles et limons de la rive droite",
        viticulture: "Rendements modérés, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Merlot", "Cabernet Franc", "Cabernet Sauvignon"],
        white: ["Sauvignon Blanc", "Sémillon"]
      },
      wineStyles: {
        red: "Vins rouges élégants et fruités, tannins doux et soyeux",
        white: "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes blanches, volailles, fromages doux"
    },
    graves: {
      name: "Graves",
      description: "Les Graves produisent des vins rouges et blancs de qualité, avec une forte proportion de vins blancs secs.",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols de graves et argiles",
        viticulture: "Rendements limités, élevage en barriques"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Merlot", "Cabernet Franc"],
        white: ["Sauvignon Blanc", "Sémillon", "Muscadelle"]
      },
      wineStyles: {
        red: "Vins rouges structurés et équilibrés",
        white: "Vins blancs secs, aromatiques et complexes"
      },
      foodPairing: "Poissons, fruits de mer, volailles, fromages de chèvre"
    }
  },
  mapAreas: [
    { region: "Médoc", x: 25, y: 70, color: "#4B164C", size: 7 },
    { region: "Saint-Émilion", x: 35, y: 72, color: "#6d2c7a", size: 6 },
    { region: "Graves", x: 30, y: 75, color: "#8a4a8a", size: 5 }
  ],
  statistics: {
    totalArea: "120,000 ha",
    production: "5.5 million hectolitres",
    redPercentage: "85%",
    whitePercentage: "15%",
    appellations: "60+ appellations"
  },
  history: "La viticulture bordelaise remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques viticoles. Le XVIIIe siècle a vu l'émergence des grands châteaux et la classification de 1855 a établi la hiérarchie des crus. Aujourd'hui, Bordeaux reste la référence mondiale pour les vins rouges de qualité."
}); 